import { Cabinet, CabinetEntry, Room } from 'shared/interfaces';
import { CabinetEntryWithCabinet, AugmentedRoom } from './interfaces';

export function augmentRoom(room: Room, cabinetList: Cabinet[], arcadeId: string): AugmentedRoom {
    const cabinets = room.cabinets.map((entry: CabinetEntry): CabinetEntryWithCabinet => {
        const cabinet = cabinetList.find((cabinet) => cabinet.cabinetId === entry.cabinetId);
        return { ...entry, cabinet };
    });
    return { ...room, cabinets, arcadeId };
}
